import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import JToggleButton from '../game/JToggleButton';
import gameData, { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import GameScreen from './GameScreen';
import FontKeys from '../FontKeys';

export default class ClockScreen extends Phaser.Scene {
  static get KEY() { return 'ClockScreen'; }

  constructor() {
    super({ key: ClockScreen.KEY });
  }

  create() {
    const backgroundImage = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._choose_clock_background, this).setOrigin(0);

    const headerText = ABCyaPhaser.Text.addText(this.scale.width / 2,90,120, 0xeaf7d2, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('clock_select_screen.header'), this, true).setShadow(6,6,'#00000073')
      .setPadding(5);

    this.analogButton = new JToggleButton(this, UIAssetKeys._analog_clock);
    this.analogButton.x = this.scale.width / 2 - 250;
    this.analogButton.y = this.scale.height / 2;
    this.analogButton.doAction = this.analogClicked.bind(this);
    this.add.existing(this.analogButton);
    this.analogButton.scale = 0.85;
    this.analogButton.doClick(true);

    const analogLabel = ABCyaPhaser.Text.addText(266,569,64, 0xeaf7d2, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('clock_select_screen.analog_clock_label'), this, true).setShadow(6,6,'#000000a0')
      .setPadding(10);

    ABCyaPhaser.Tweens.addTween([analogLabel, this.analogButton], 500, { delay: 100, scale: 1.1 }, Phaser.Math.Easing.Bounce.Out, () => {
      ABCyaPhaser.Tweens.addTween([analogLabel,this.analogButton], 200, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
    });

    this.digitalButton = new JToggleButton(this,UIAssetKeys._digital_clock);
    this.digitalButton.x = this.scale.width / 2 + 250;
    this.digitalButton.y = this.scale.height / 2;
    this.digitalButton.doAction = this.digitalClicked.bind(this);
    this.add.existing(this.digitalButton);
    this.digitalButton.scale = 0.85;
    const digitalLabel = ABCyaPhaser.Text.addText(776,558,64, 0xeaf7d2, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('clock_select_screen.digital_clock_label'), this, true).setShadow(6,6,'#000000a0')
      .setPadding(10);
    ABCyaPhaser.Tweens.addTween([digitalLabel, this.digitalButton], 500, { delay: 400, scale: 1.1 }, Phaser.Math.Easing.Bounce.Out, () => {
      ABCyaPhaser.Tweens.addTween([digitalLabel,this.digitalButton], 200, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
    });

    this.nextButton = ABCyaPhaser.Buttons.addDefaultButton(this.scale.width / 2, 660, UIAssetKeys._next_button, null, SoundAssetKeys._click, this.cleanUp.bind(this), this, { ...DEFAULT_BUTTON_CONFIG });

    this.cameras.main.zoom = 0;

    this.transitionIn();
  }

  analogClicked () {
    gameData.CLOCK_IS_ANALOG = true;
  }

  digitalClicked () {
    gameData.CLOCK_IS_ANALOG = false;
  }

  cleanUp () {
    this.scene.start(GameScreen.KEY);
  }

  transitionIn () {
    const totalRotation = 2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 1 }, Phaser.Math.Easing.Linear);
  }
}